import { IS_NATIVE_APP } from '../config/environment'

const NATIVE_STORAGE_PREFIX = 'tunetoss_'

type SecureStorageModule = typeof import('@aparajita/capacitor-secure-storage')

let secureStorageModule: Promise<SecureStorageModule> | null = null
let storageReady: Promise<void> | null = null

export async function getNativeSecureItem(key: string): Promise<string | null> {
	const { SecureStorage: storage } = await prepareSecureStorage()
	return storage.getItem(key)
}

export async function setNativeSecureItem(
	key: string,
	value: string,
): Promise<void> {
	const { SecureStorage: storage } = await prepareSecureStorage()
	await storage.setItem(key, value)
}

export async function removeNativeSecureItem(key: string): Promise<void> {
	const { SecureStorage: storage } = await prepareSecureStorage()
	await storage.removeItem(key)
}

async function prepareSecureStorage(): Promise<SecureStorageModule> {
	if (!IS_NATIVE_APP) {
		throw new Error('Native secure storage is unavailable in a web build.')
	}

	secureStorageModule ??= import('@aparajita/capacitor-secure-storage')
	const module = await secureStorageModule
	const { KeychainAccess, SecureStorage } = module
	storageReady ??= Promise.all([
		SecureStorage.setKeyPrefix(NATIVE_STORAGE_PREFIX),
		SecureStorage.setSynchronize(false),
		SecureStorage.setDefaultKeychainAccess(
			KeychainAccess.whenUnlockedThisDeviceOnly,
		),
	]).then(() => undefined)
	await storageReady
	// A Capacitor proxy exposes a synthetic `then` method. Returning it directly
	// from an async function makes promise resolution hang during app startup.
	return module
}
